import { storyblokEditable } from "@storyblok/react";
import { PageModel } from "../Models/PageModel";

const Page: React.FC<{ blok: PageModel }> = ({ blok }) => (
  <div>
    <main {...storyblokEditable(blok)}></main>
  </div>
);

export default Page;
